import { useContext } from 'react';
import UnlockTimerContext from '~/context/vdp/UnlockTimerContext';
import useAlertStatus from './useAlertStatus';
import useIsInExclusivePreview from './useIsInExclusivePreview';

export default function useIsOnHold() {
  const { isInitialized, shouldShowTimer } = useContext(UnlockTimerContext);
  const { purchasePending } = useAlertStatus();
  const isInExclusivePreview = useIsInExclusivePreview();

  return (
    (isInExclusivePreview || purchasePending) &&
    shouldShowTimer &&
    isInitialized
  );
}
